export const DISPLAY_MODE = {
	TABLE: 'table',
	LARGE: 'large',
};

export const SORT = {
	ASC: 'ASC',
	DESC: 'DESC',
};
